import React from 'react';
import { GlobeIcon, MailIcon, FileTextIcon } from 'lucide-react';
export const Services = () => {
  return <section id="services" className="py-20 border-b border-gray-100 bg-[#f9fafb]" data-id="element-501">
      <div className="container mx-auto px-4" data-id="element-502">
        <div className="text-center mb-16" data-id="element-503">
          <h2 className="text-base text-green-600 font-semibold tracking-wide uppercase mb-2" data-id="element-504">
            SERVICES
          </h2>
          <p className="text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-505">
            Copy That Actually Works
          </p>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-506">
            Stop losing customers to boring copy. We don't just write words. We
            write revenue-generating machines disguised as copy.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-507">
          {/* Email Campaigns */}
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300" data-id="element-508">
            <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center text-white text-2xl mb-4" data-id="element-509">
              <MailIcon className="h-8 w-8" data-id="element-510" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-[#2c3e50]" data-id="element-511">
              Email Campaigns
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-512">
              Strategic sequences that turn subscribers into buyers.
            </p>
            <div className="mt-4" data-id="element-513">
              <h4 className="font-bold text-[#2c3e50] mb-2" data-id="element-514">What You Get:</h4>
              <ul className="space-y-1" data-id="element-515">
                <li className="flex items-start gap-2" data-id="element-516">
                  <span className="text-green-600 font-bold" data-id="element-517">✓</span>
                  <span className="text-gray-600" data-id="element-518">Welcome sequences</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-519">
                  <span className="text-green-600 font-bold" data-id="element-520">✓</span>
                  <span className="text-gray-600" data-id="element-521">Sales funnels</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-522">
                  <span className="text-green-600 font-bold" data-id="element-523">✓</span>
                  <span className="text-gray-600" data-id="element-524">Retention campaigns</span>
                </li>
              </ul>
            </div>
          </div>
          {/* Brand Messaging */}
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300" data-id="element-525">
            <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center text-white text-2xl mb-4" data-id="element-526">
              <span className="text-3xl" data-id="element-527">🎯</span>
            </div>
            <h3 className="text-xl font-bold mb-2 text-[#2c3e50]" data-id="element-528">
              Brand Messaging
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-529">
              Strategic brand positioning that sets you apart from competitors.
            </p>
            <div className="mt-4" data-id="element-530">
              <h4 className="font-bold text-[#2c3e50] mb-2" data-id="element-531">What You Get:</h4>
              <ul className="space-y-1" data-id="element-532">
                <li className="flex items-start gap-2" data-id="element-533">
                  <span className="text-green-600 font-bold" data-id="element-534">✓</span>
                  <span className="text-gray-600" data-id="element-535">Brand positioning</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-536">
                  <span className="text-green-600 font-bold" data-id="element-537">✓</span>
                  <span className="text-gray-600" data-id="element-538">Voice guidelines</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-539">
                  <span className="text-green-600 font-bold" data-id="element-540">✓</span>
                  <span className="text-gray-600" data-id="element-541">Competitor analysis</span>
                </li>
              </ul>
            </div>
          </div>
          {/* Sales Pages */}
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300" data-id="element-542">
            <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center text-white text-2xl mb-4" data-id="element-543">
              <FileTextIcon className="h-8 w-8" data-id="element-544" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-[#2c3e50]" data-id="element-545">
              Sales Pages
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-546">
              High-converting sales pages that guide prospects to purchase.
            </p>
            <div className="mt-4" data-id="element-547">
              <h4 className="font-bold text-[#2c3e50] mb-2" data-id="element-548">What You Get:</h4>
              <ul className="space-y-1" data-id="element-549">
                <li className="flex items-start gap-2" data-id="element-550">
                  <span className="text-green-600 font-bold" data-id="element-551">✓</span>
                  <span className="text-gray-600" data-id="element-552">Long-form sales pages</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-553">
                  <span className="text-green-600 font-bold" data-id="element-554">✓</span>
                  <span className="text-gray-600" data-id="element-555">Multi-step funnels</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-556">
                  <span className="text-green-600 font-bold" data-id="element-557">✓</span>
                  <span className="text-gray-600" data-id="element-558">Upsell sequences</span>
                </li>
              </ul>
            </div>
          </div>
          {/* Marketing Content */}
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300" data-id="element-559">
            <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center text-white text-2xl mb-4" data-id="element-560">
              <span className="text-3xl" data-id="element-561">📱</span>
            </div>
            <h3 className="text-xl font-bold mb-2 text-[#2c3e50]" data-id="element-562">
              Marketing Content
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-563">
              Social posts, ads, and sales materials that drive results.
            </p>
            <div className="mt-4" data-id="element-564">
              <h4 className="font-bold text-[#2c3e50] mb-2" data-id="element-565">What You Get:</h4>
              <ul className="space-y-1" data-id="element-566">
                <li className="flex items-start gap-2" data-id="element-567">
                  <span className="text-green-600 font-bold" data-id="element-568">✓</span>
                  <span className="text-gray-600" data-id="element-569">Engaging social media</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-570">
                  <span className="text-green-600 font-bold" data-id="element-571">✓</span>
                  <span className="text-gray-600" data-id="element-572">Authority blog posts</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-573">
                  <span className="text-green-600 font-bold" data-id="element-574">✓</span>
                  <span className="text-gray-600" data-id="element-575">Voice guidelines</span>
                </li>
              </ul>
            </div>
          </div>
          {/* Ad Copy */}
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300" data-id="element-576">
            <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center text-white text-2xl mb-4" data-id="element-577">
              <span className="text-3xl" data-id="element-578">📢</span>
            </div>
            <h3 className="text-xl font-bold mb-2 text-[#2c3e50]" data-id="element-579">Ad Copy</h3>
            <p className="text-gray-600 mb-4" data-id="element-580">
              Attention-grabbing, click-worthy ad copy that delivers ROI.
            </p>
            <div className="mt-4" data-id="element-581">
              <h4 className="font-bold text-[#2c3e50] mb-2" data-id="element-582">What You Get:</h4>
              <ul className="space-y-1" data-id="element-583">
                <li className="flex items-start gap-2" data-id="element-584">
                  <span className="text-green-600 font-bold" data-id="element-585">✓</span>
                  <span className="text-gray-600" data-id="element-586">Social media ads</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-587">
                  <span className="text-green-600 font-bold" data-id="element-588">✓</span>
                  <span className="text-gray-600" data-id="element-589">Google Ads copy</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-590">
                  <span className="text-green-600 font-bold" data-id="element-591">✓</span>
                  <span className="text-gray-600" data-id="element-592">A/B testing</span>
                </li>
              </ul>
            </div>
          </div>
          {/* Website Copy */}
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300" data-id="element-593">
            <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center text-white text-2xl mb-4" data-id="element-594">
              <GlobeIcon className="h-8 w-8" data-id="element-595" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-[#2c3e50]" data-id="element-596">
              Website Copy
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-597">
              Headlines that hook, pages that convert visitors into customers.
            </p>
            <div className="mt-4" data-id="element-598">
              <h4 className="font-bold text-[#2c3e50] mb-2" data-id="element-599">What You Get:</h4>
              <ul className="space-y-1" data-id="element-600">
                <li className="flex items-start gap-2" data-id="element-601">
                  <span className="text-green-600 font-bold" data-id="element-602">✓</span>
                  <span className="text-gray-600" data-id="element-603">Converting headlines</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-604">
                  <span className="text-green-600 font-bold" data-id="element-605">✓</span>
                  <span className="text-gray-600" data-id="element-606">Trust-building pages</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-607">
                  <span className="text-green-600 font-bold" data-id="element-608">✓</span>
                  <span className="text-gray-600" data-id="element-609">Irresistible CTAs</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};